module.exports = __webpack_public_path__ + "static/media/four_friend_page04.a11faa4d.png";